var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Dropdown',{attrs:{"options":_vm.options,"handleSelection":_vm.handler,"placeholder":"Expertise Level","selectedOption":_vm.interestArea.expertiseLevel,"appendToBody":_vm.append,"clearable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }